'use client';

import { useState } from 'react';
import { LuCopy } from 'react-icons/lu';
import { useCopyToClipboard } from 'usehooks-ts';

import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';

import { DATA_CY_STORE_DISCOUNT_COPY } from '@/constant/cypress';
import localization from '@/constant/localization';

type Props = {
  code: string;
};

export default function CopyLink({ code }: Props) {
  const [, copy] = useCopyToClipboard();
  const [buttonTitle, setButtonTitle] = useState<string>(localization.copyDiscountCode);
  const handleCopyButtonCLick = () => {
    copy(code)
      .then(() => {
        setButtonTitle(localization.copied);
      })
      .catch((error) => {
        console.error('Failed to copy!', error);
      });
  };
  return (
    <Container
      center
      className='mx-2 mb-2 flex h-[57px] w-full justify-evenly rounded-[10px] bg-[#6097F314] px-1.5 py-2 md:mx-0 md:mb-0 md:justify-end'
    >
      <Text className='line-clamp-1 overflow-hidden px-2 py-[10px] text-sm text-[#5B5C60]'>
        {code}
      </Text>
      <Button
        data-cy={DATA_CY_STORE_DISCOUNT_COPY}
        variant={VARIANT_ENUM.OUTLINED}
        onClick={handleCopyButtonCLick}
        className='h-[39px] min-w-[80px] rounded-[7px] border-[#6097F3] bg-[#FFFFFF] px-4 text-[13px] font-bold whitespace-nowrap text-[#6097F3] hover:bg-[#6097F3] md:px-1.5!'
        Icon={<LuCopy size={16} />}
      >
        {buttonTitle}
      </Button>
    </Container>
  );
}
